var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('LayoutHeader'),_c('router-view',{staticClass:"header"}),_c('LayoutFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }